import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createSelector } from "reselect";
import { mapValues } from "./object.js";
import { handleError } from "../errors/error_handler.js";
export var onActionMiddleware = function onActionMiddleware(type, f) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === type) {
          f(action);
        }
        return next(action);
      };
    };
  };
};
export var asyncAction = function asyncAction(_ref) {
  var typePrefix = _ref.typePrefix,
    loadPayload = _ref.loadPayload,
    _ref$ifPredicate = _ref.ifPredicate,
    ifPredicate = _ref$ifPredicate === void 0 ? function () {
      return true;
    } : _ref$ifPredicate;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var type, payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            type = function type(step) {
              return "".concat(typePrefix, "_").concat(step);
            };
            if (ifPredicate(getState())) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            dispatch({
              type: type("LOADING")
            });
            _context.prev = 4;
            _context.next = 7;
            return loadPayload();
          case 7:
            payload = _context.sent;
            dispatch({
              type: type("LOADED"),
              payload: payload
            });
            return _context.abrupt("return", payload);
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](4);
            dispatch({
              type: type("FAILED"),
              payload: {
                error: _context.t0
              }
            });
            throw _context.t0;
          case 16:
            _context.prev = 16;
            dispatch({
              type: type("DONE")
            });
            return _context.finish(16);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 12, 16, 19]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var createConverterSelector = function createConverterSelector(selector) {
  return createSelector([selector], function (value) {
    return value && typeof value.toJS === "function" ? value.toJS() : value;
  });
};
export var createStateToProps = function createStateToProps(propsToSelectors) {
  return function () {
    var selectorMap = mapValues(propsToSelectors, createConverterSelector);
    return function (state, ownProps) {
      return mapValues(selectorMap, function (selector) {
        return selector(state, ownProps);
      });
    };
  };
};
export var errorMiddleware = function errorMiddleware(store) {
  return function (next) {
    return function (action) {
      try {
        // Handle actions that are instances of Error
        if (action instanceof Error) {
          store.dispatch(handleError(action));
          return;
        }

        // Call the next middleware in the chain
        var result = next(action);
        if (result instanceof Promise) {
          result["catch"](function (error) {
            if (error !== null && error !== void 0 && error.__handledByErrorMiddleware) {
              return;
            }
            ;
            // ignore this type of errors beucase they are handled by the redux store already
            if (error.type === "VALIDATION_FAILED") {
              return;
            }
            // this is already handled by its own error handler
            if (error.type === "RESET_PASSWORD_TOKEN_INVALID") {
              return;
            }
            if (error.type === "CAPTCHA_REQUIRED") {
              return;
            }
            if (error.type === "LOGIN_INVALID") {
              return;
            }
            error.__handledByErrorMiddleware = true;
            var safeError = _objectSpread({}, error);
            var newAction = handleError(safeError);
            if (newAction) {
              store.dispatch(newAction);
            } else {
              return;
            }
          });
        }
        return result;
      } catch (error) {
        // Catch synchronous errors
        if (!error.__handledByErrorMiddleware) {
          error.__handledByErrorMiddleware = true;
          var safeError = _objectSpread({}, error);
          var newAction = handleError(safeError);
          if (newAction) {
            store.dispatch(newAction);
          } else {
            return;
          }
        }
        throw error; // Ensure React error boundaries still catch it
      }
    };
  };
};